export { State as DeployState, reducer as deployReducer } from './reducer';
export { saga as deploySaga } from './saga';

import * as deployActions from './actions';
import * as deploySelectors from './selectors';
export { deployActions, deploySelectors };
